// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","title":"Header_title__XruNr","subtitle":"Header_subtitle__a7cFK","fadeIn":"Header_fadeIn__--yPP"};